<template>
    <div class="history">
        <prolong-filter-block :is-load-xml="condition.idLoadXml"
                              @download-xls="downloadXls()"
                              :is-load-data="condition.isLoadTable"
                              :orders="orders"
                              @init-orders-list="initList(1)"
                              :dates="settedDates"
                              ref="filter"></prolong-filter-block>
        <prolong-list ref="orderList"
                     @init-orders-list="initList"
                     @filter-status-wrap="filterStatusWrap()"
                     @change-filter-params="changeFilterParams"
                     :count-prolongation="countProlongation"
                     :prolong-statuses="prolongClientStatuses"
                     :is-load-data="condition.isLoadTable"
                     :is-mobile="this.condition.isMobile"
                     :orders="orders"></prolong-list>
        <div style="text-align: center">
            <pagination v-show="total > 0" :total="total"
                        :page.sync="listQuery.page"
                        :limit.sync="listQuery.limit" @pagination="initList()" />
        </div>
    </div>
</template>


<script>
    import Vue from "vue";
    import {orderMixin} from '@/mixin'
    import Pagination from '@/components/Pagination';
    import {list as listOrders, prolongation as listProlongation,  downloadExcel} from "@/api/order";
    import { default as prolongList } from "@/views/prolongation/prolongList.vue";
    import { default as ProlongFilterBlock } from "@/views/prolongation/prolongFilter";

    const FileDownload = require('js-file-download');

    export default {
        mixins: [orderMixin],
        components: {
            prolongList,
            Pagination,
            ProlongFilterBlock
        },
        data: function () {
            return {
                orders: [],
                total: 1,
                requestSeq: 0,
                countProlongation: 0,
                mobileWith: 992,
                settedDates: [],
                condition: {
                    isLoadTable: true,
                    isLoadXml: false,
                    isMobile: false,
                },
                listQuery: {
                    page: 1,
                    limit: 10,
                }
            }
        },
        created: function() {
            window.addEventListener("resize", this.checkWindowResize);
            this.checkIsMobile();
            this.setDatesFromUrl();
        },
        mounted: function() { // The hook. Here, Vue has already worked its magic.
          this.setMtsbuCodeFromUrl();
          this.initList();
        },
        computed:{
            prolongClientStatuses: function () {
                return this.$store.getters.PROLONG_STATUSES;
            },
        },
        methods: {
            checkIsMobile: function() {
                return this.condition.isMobile = window.innerWidth < this.mobileWith;
            },
            checkWindowResize: function() {
                this.checkIsMobile()
            },
            filterStatusWrap: function() {
                this.$refs.filter.filterStatusWrap(true);
            },
            setDatesFromUrl() {
              const { finishedFrom } = this.$route.query;
              if (finishedFrom) {
                this.settedDates = [
                  moment(finishedFrom, 'DD.MM.YYYY').toDate(),
                  moment(finishedFrom, 'DD.MM.YYYY').toDate()
                ];
              }
            },
            setMtsbuCodeFromUrl() {
              const { mtsbuCode } = this.$route.query;
              if (mtsbuCode) {
                this.$refs.filter.listQuery.mtsbuCode = mtsbuCode;
              }
            },
            changeFilterParams: function(dates, page) {
                this.$refs.filter.dateFilter = dates;
                this.listQuery.page = 1;
            },
            getQuery: function () {
                return {...this.$refs.filter.listQuery, ...this.$refs.orderList.listQuery, ...this.listQuery};
            },
            downloadXls : async function() {
                Vue.set(this.condition, 'idLoadXml', true);

                let response = await downloadExcel(this.getQuery());

                if (response?.data) {
                    FileDownload(response.data, 'report.xlsx');
                }

                Vue.set(this.condition, 'idLoadXml', false);
            },
            initList: async function (filterButtonEvent) {
                if (filterButtonEvent === 1) {
                    this.listQuery.page = 1;
                }
                const seq = ++this.requestSeq;
                let response;
                this.orders = [];
                this.condition.isLoadTable = true;

                response = await listProlongation(this.getQuery());
                if (seq !== this.requestSeq) return;
                const { data } = response;

                this.countProlongation = data.data?.countProlongation ?? data.data?.total;
                this.orders = data.data.items;
                this.total = data.data?.total;
                this.condition.isLoadTable = false;
            },
        },
        destroyed() {
            window.removeEventListener("resize", this.checkWindowResize);
        },
    }
</script>
